import React from "react";

const SoundWave = () => {
  return (
    <svg
      width="12"
      height="27"
      viewBox="0 0 12 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.96712 23.3452C2.87297 18.2665 2.87291 8.69373 8.96712 3.61523"
        stroke="#00A799"
        strokeWidth="1.0157"
      />
      <path
        d="M10.9983 20.7977C6.93548 17.2426 6.93544 9.63305 10.9983 6.07812"
        stroke="#00A799"
        strokeWidth="1.0157"
      />
      <path
        d="M6.91787 25.9868C-0.972593 18.8735 -0.972647 8.33655 6.91785 1"
        stroke="#00A799"
        strokeWidth="1.0157"
      />
    </svg>
  );
};

export default SoundWave;
